import { styled, css } from 'styled-components';
import { IconProps } from '.';

interface Props extends IconProps {
  $useStroke: boolean;
}

export const Container = styled.svg<Props>`
  ${({ theme: { colors }, color = 'brandPrimary', strokeWidth = 1.5, $useStroke = true }) => css`
    ${
      $useStroke &&
      css`
        fill: transparent;

        path {
          stroke: ${color && colors[color]};
          stroke-width: ${strokeWidth};
        }
      `
    }

    ${
      !$useStroke &&
      css`
        fill: ${color && colors[color]};

        path:not([stroke]) {
          stroke: unset !important;
          stroke-width: 0 !important;
        }
      `
    }
  `}
`;
